








































import { Vue, Component } from "vue-property-decorator";
import CdkImagePlaceholder from "../SlcNewsItem/ContentRows/CdkImagePlaceholder.vue";
import CdkImage from "../SlcNewsItem/ContentRows/CdkImage.vue";

@Component({
  components: {
    CdkImagePlaceholder,
    CdkImage
  }
})
export default class ContentImage extends Vue {}
